module.exports = {
	"data": {
		"markdownRemark": {
			"html": "<h3>Where are the demo URLs?</h3>\n<ul>\n<li>Todo App: <a href=\"https://todo.semanticlink.io\">https://todo.semanticlink.io</a></li>\n<li>API: <a href=\"https://api.todo.semanticlink.io\">https://api.todo.semanticlink.io</a></li>\n</ul>\n<h3>What are the credentials?</h3>\n<ul>\n<li><strong>user</strong>: test-1@semanticlink.io</li>\n<li><strong>password</strong>: 1234qwerZXCV</li>\n</ul>\n<h3>Why isn’t this more of a tutorial describing what hypermedia is?</h3>\n<p>This is a tutorial series for the dedicated. It is assumes a baseline level of knowledge and these tutorials are about <strong>how</strong> implementations are done. This is a place to read documented code and look at abstractions and code organisation. The proof is in the ease of use and understanding. If you are looking for what is hypermedia or why then there exists plenty of material via a quick search and loads of books on the subject in the last ten years—see below.</p>\n<h3>What is hoped out of <strong>How to Hypermedia</strong>?</h3>\n<p>That on getting some examples built that are comparable, there is a pragmatic step forwards such that somebody comes up with that secret sauce that moves hypermedia from the dedicated to the mainstream. It is likely that a query abstraction (like Neo4j’s graphite or GraphQL) over the top of a good client application cache (per client). On the API, there must be a better way than all this boilerplate code. Yet, that tends towards a domain specific language (DSL) that moves away from a general purpose language where it by repetition and exception, the essential and accidental are separated. So perhaps it will come from a simplified-REST-inspired-without-the-legacy-bloat serverless-side framework that has clean relative (ie not a flat namespaced) routing. Put differently, the current decades old approaches to MVC make the simple aspects that we should almost get for free way too hard and time consuming. [/end of rant]</p>\n<h3>What’s the story about the Authentication?</h3>\n<p>The todo app should ideally have this implemented outside the application.The current implementation using the credentials above is using <a href=\"https://auth0.com\">Auth0</a>. Basically, it has a free plan that demonstrated the point well enough.</p>\n<h3>What about Authorisation?</h3>\n<p>The todo app can either implement a resource-based or role-based access control. Currently, no chapters explain the (simplified) implementation in the code base.</p>\n<h3>What’s missing in all this puzzle?</h3>\n<ul>\n<li>client-side binding to resources: profiles, can we get around compile time bindings?</li>\n<li>client-side binding to field types in forms: this currently hard coded and not exposed via the API (so devs would need ‘documentation’ to do this)</li>\n<li>domain knowledge: how do we know what the API at a big picture looks like (json-home, sequence diagrams, dot notation diagrams, API specs)</li>\n</ul>\n<h3>Why is the tutorial code primarily in one repository?</h3>\n<p>Currently, at this stage it is easier to keep everything in one repository keeping everything in sync and that the utility libraries are also still “under development”. Separate folders are good enough for now but with reason can be made into package managed libraries.</p>\n<h3>What books/resources are there on Hypermedia?</h3>\n<ul>\n<li>\n<p>Mike Amundsen: eg <a href=\"https://www.infoq.com/articles/hypermedia-api-tutorial-part-one\">Designing and Implementing Hypermedia APIs</a></p>\n<ul>\n<li><a href=\"http://shop.oreilly.com/product/0636920020530.do\">Building Hypermedia APIs with HTML5 and Node: Creating Evolvable Hypermedia Applications</a></li>\n<li><a href=\"http://shop.oreilly.com/product/0636920028468.do\">RESTful Web APIs: Services for a Changing World</a></li>\n<li><a href=\"http://shop.oreilly.com/product/0636920037958.do\">RESTful Web Clients: Enabling Reuse Through Hypermedia</a></li>\n<li><a href=\"http://dret.net/lectures/www-2019/2019-05-www-api-styles.pdf\">Five API Styles</a></li>\n</ul>\n</li>\n<li>Irakli Nadareishvili: <a href=\"http://youtu.be/_UG7u7ARTfM%253Ft=35m25s\">Video</a> and <a href=\"https://www.freshblurbs.com/blog/2013/10/22/web-of-apis-hypermedia-collection-document.html\">Transcript</a> of a Talk on Hypermedia</li>\n<li>Steve Klabnik: <a href=\"http://www.designinghypermediaapis.com/\">Designing Hypermedia APIs</a>and <a href=\"https://www.youtube.com/watch?v=g4sqydY3hHU\">Video</a></li>\n<li>Roy Fielding: <a href=\"https://www.ics.uci.edu/~fielding/pubs/dissertation/rest_arch_style.htm\">Representational State Transfer (REST)</a></li>\n<li><a href=\"http://apistylebook.com/\">API StyleBook</a>: collection of resources for API designers (from various providers like Atlassian, Google, Microsoft, PayPal, Redhat)</li>\n<li><a href=\"https://blog.goodapi.co/rest-vs-graphql-a-critical-review-5f77392658e7\">REST vs. GraphQL: A Critical Review</a>: great section on REST cons (suggesting that hypermedia is for the dedicated)!</li>\n</ul>",
			"fields": {
				"slug": "/advanced/4-common-questions/"
			},
			"excerpt": "Where are the demo URLs? Todo App:  https://todo.semanticlink.io API:  https://api.todo.semanticlink.io What are the credentials? user...",
			"frontmatter": {
				"title": "Common Questions",
				"videoId": null,
				"videoAuthor": null,
				"parent": "/Users/todd/src/howtohypermedia/content/hypermedia/advanced/4-common-questions.md absPath of file",
				"question": null,
				"answers": null,
				"correctAnswer": null,
				"description": "Answer common questions about these tutorials",
				"pageTitle": "Common Questions"
			}
		},
		"mds": {
			"edges": [
				{
					"node": {
						"frontmatter": {
							"title": "Get started with your favorite technology",
							"description": null
						},
						"fields": {
							"slug": "/choose/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Update Collection Resource",
							"description": "Learn the code mechanics of a edit forms on a collection resource that uses different mime-types"
						},
						"fields": {
							"slug": "/aspnetcore-todo-api/11-update-collection/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "It was great having you!",
							"description": null
						},
						"fields": {
							"slug": "/success/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Update Singleton Resource",
							"description": "Learn the code mechanics of a edit forms on a singleton resource"
						},
						"fields": {
							"slug": "/aspnetcore-todo-api/10-update-singleton/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Introduction",
							"description": "Learn how to build a hypermedia API that works within the constraints of REST"
						},
						"fields": {
							"slug": "/aspnetcore-todo-api/0-introduction/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Getting Started",
							"description": "Learn how to build a hypermedia API "
						},
						"fields": {
							"slug": "/aspnetcore-todo-api/1-getting-started/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "",
							"description": null
						},
						"fields": {
							"slug": "/aspnetcore-todo-api/2-modelling-representations/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Modelling Domain",
							"description": "Learn how to diagram the API textually and get also get visual output"
						},
						"fields": {
							"slug": "/aspnetcore-todo-api/3-modelling-domain-link-relations/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Constructing Representations",
							"description": "Learn the code mechanics of request/response of representation in an MVC framework with the root API representation containing links and a version"
						},
						"fields": {
							"slug": "/aspnetcore-todo-api/4-constructing-representations/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Constructing Collections",
							"description": "Learn the code mechanics of a singleton resource with the user resource"
						},
						"fields": {
							"slug": "/aspnetcore-todo-api/6-constructing-collection/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Constructing Searchable Resources",
							"description": "Learn the code mechanics of a search forms on a collection"
						},
						"fields": {
							"slug": "/aspnetcore-todo-api/8-constructing-search-resources/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Constructing Singletons",
							"description": "Learn the code mechanics of a singleton resource with the user resource"
						},
						"fields": {
							"slug": "/aspnetcore-todo-api/5-constructing-singleton/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Create Resource",
							"description": "Learn the code mechanics of a create forms on a collection"
						},
						"fields": {
							"slug": "/aspnetcore-todo-api/9-create-resource/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Constructing Virtual Resource",
							"description": "Learn the code mechanics of a virtual resource with the user resource"
						},
						"fields": {
							"slug": "/aspnetcore-todo-api/7-constructing-viritual/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Introduction",
							"description": "Learn how to build a todo app and admin functions over the top of a hypermedia API"
						},
						"fields": {
							"slug": "/vue-todo-app/0-introduction/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Client-side URLs and routing",
							"description": "Design your application around the holding and reconstructing client state through the URI in the browser location requires matching client views and the data it requires"
						},
						"fields": {
							"slug": "/vue-todo-app/2-client-side-urls-and-routing/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Getting started",
							"description": "Learn how to build a todo client to use the hypermedia API "
						},
						"fields": {
							"slug": "/vue-todo-app/1-getting-started/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Client-side application cache",
							"description": "Client need to have one copy of representations in the application cache"
						},
						"fields": {
							"slug": "/vue-todo-app/3-application-cache/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Updates and deletes",
							"description": "The application cache also deals with the updates and deletion of resources"
						},
						"fields": {
							"slug": "/vue-todo-app/4-updates-and-deletes/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "On-demand Authentication",
							"description": "Be able to create and renew authentication tokens when the server requests valid authentication tokens"
						},
						"fields": {
							"slug": "/vue-todo-app/5-on-demand-authentication/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Summary",
							"description": "Learn how to build a todo app over the top of a hypermedia API"
						},
						"fields": {
							"slug": "/vue-todo-app/7-summary/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Getting Started",
							"description": "Learn how to build a general purpose client to browse over the API "
						},
						"fields": {
							"slug": "/vue-api-browser/1-getting-started/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Cloning Resources",
							"description": "Forms in hypermedia make cloning of trees straightforward and we can leverage that with drag and drop functionality alongside the client-side application cache"
						},
						"fields": {
							"slug": "/vue-todo-app/6-cloning-resources/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "HTML representation",
							"description": "Learn what and why to build HTML representation of data with code on demand"
						},
						"fields": {
							"slug": "/vue-api-browser/2-build-html-representation/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Introduction",
							"description": "Learn how to build a general purpose client to browse over the API "
						},
						"fields": {
							"slug": "/vue-api-browser/0-introduction/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Generate HTML",
							"description": "Learn how to respond as HTML in ASP.NET Core"
						},
						"fields": {
							"slug": "/vue-api-browser/3-build-html-content-negotiation/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Register text/html",
							"description": "Learn how to respond to HTML content negotiation in ASP.NET Core"
						},
						"fields": {
							"slug": "/vue-api-browser/4-register-html-content-negotiation/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "GET application/json",
							"description": "Learn how to request JSON from the client"
						},
						"fields": {
							"slug": "/vue-api-browser/5-request-json/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Summary",
							"description": "Learn how to user hypermedia as engine to navigate an API and make changes"
						},
						"fields": {
							"slug": "/vue-api-browser/10-summary/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Displaying with interaction",
							"description": "Learn how to process JSON to make delete, create and update"
						},
						"fields": {
							"slug": "/vue-api-browser/6-displaying-with-interaction/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Displaying forms",
							"description": "Learn how to process form values for create and edit forms"
						},
						"fields": {
							"slug": "/vue-api-browser/8-displaying-form-values/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Deleting a resource",
							"description": "Learn how to process JSON to try and delete a resource"
						},
						"fields": {
							"slug": "/vue-api-browser/7-try-delete-representation/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Introduction",
							"description": "Learn all about hypermedia and why a REST-style of architecture is simple and subtle. It's not really for the lazy or those who like to be clever."
						},
						"fields": {
							"slug": "/basics/0-introduction/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Minimally layered design",
							"description": "Learn why hypermedia is a thin layer across persistence that should guide us through the business problem."
						},
						"fields": {
							"slug": "/basics/1-minimally-layered-design/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Submitting forms",
							"description": "Learn how to process creates (POST) and updates (PUT) on a resource"
						},
						"fields": {
							"slug": "/vue-api-browser/9-submitting-forms/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Big Picture (Trends)",
							"description": "Learn that distributed applications have trended towards data and business logic being processed at the client edge"
						},
						"fields": {
							"slug": "/basics/3-big-picture/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Hypermedia for the dedicated",
							"description": "Learn some techniques that will ease the server and client development"
						},
						"fields": {
							"slug": "/basics/4-for-the-dedicated/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Navigating a hypermedia API",
							"description": "Learn what a hypermedia looks like to be able to explore a domain."
						},
						"fields": {
							"slug": "/basics/2-navigating-api/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Multiple clients",
							"description": "Learn that most APIs should have multiple types of clients."
						},
						"fields": {
							"slug": "/advanced/0-multiple-clients/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "API Modelling",
							"description": "Learn about how collections and singletons are modelled in hypermedia"
						},
						"fields": {
							"slug": "/advanced/1-api-modelling/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Forms Modelling",
							"description": "Links and Forms are used to update resources and controlled by the server that the client then uses"
						},
						"fields": {
							"slug": "/advanced/2-forms-modelling/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Common Questions",
							"description": "Answer common questions about these tutorials"
						},
						"fields": {
							"slug": "/advanced/4-common-questions/"
						}
					}
				},
				{
					"node": {
						"frontmatter": {
							"title": "Todo Domain",
							"description": "Learn about domain of the API"
						},
						"fields": {
							"slug": "/advanced/3-todo-domain/"
						}
					}
				}
			]
		}
	},
	"pathContext": {
		"slug": "/advanced/4-common-questions/"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/advanced-4-common-questions.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/advanced-4-common-questions.json
// module chunks = 42